import { render } from "./SessionPointsList.vue?vue&type=template&id=59b58ae2&scoped=true"
import script from "./SessionPointsList.vue?vue&type=script&lang=js"
export * from "./SessionPointsList.vue?vue&type=script&lang=js"

import "./SessionPointsList.vue?vue&type=style&index=0&id=59b58ae2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b58ae2"]])

export default __exports__